export default "__VITE_ASSET__f9728e9a__"